// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Icon$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as CustomerTransactionTableCmp from "./CustomerTransactionTableCmp.bs.js";
import * as LoadingViewComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/LoadingViewComponent.bs.js";

function CustomerTransactionTableWrapper(Props) {
  var collapse = Props.collapse;
  var setCollapse = Props.setCollapse;
  var data = Props.data;
  var updateTable = Props.updateTable;
  var loader = Props.loader;
  return React.createElement("div", {
              className: "table-container " + (
                collapse ? "" : "full-screen-table"
              )
            }, collapse ? null : React.createElement("h2", {
                    className: "title"
                  }, "Wallet Information", React.createElement("span", {
                        onClick: (function (param) {
                            return Curry._1(setCollapse, !collapse);
                          })
                      }, React.createElement(Icon$Catalyst.CloseIcon.make, {}))), loader ? React.createElement("div", {
                    className: "loader-wrapper"
                  }, React.createElement(LoadingViewComponent$Catalyst.make, {})) : null, React.createElement(CustomerTransactionTableCmp.make, {
                  data: data,
                  updateTable: Curry.__1(updateTable),
                  loader: loader
                }));
}

var make = CustomerTransactionTableWrapper;

export {
  make ,
  
}
/* react Not a pure module */
